import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import { downloadCsvFile } from 'dashboard/helper/downloadHelper';
import { mentionHost } from './buzzMentionHelpers';

const csvCell = value => {
  const stringValue = String(value ?? '');
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

const csvRow = values => values.map(csvCell).join(',');

const formatHistoryDate = value => {
  if (!value) return '';
  const parsed = parseISO(value);
  if (!isValid(parsed)) return value;
  return format(parsed, 'yyyy-MM-dd');
};

const formatMentionDate = mention => {
  if (mention.date) return mention.date;
  if (!mention.crawled_at) return '';
  const parsed = parseISO(mention.crawled_at);
  if (!isValid(parsed)) return '';
  return format(parsed, 'yyyy-MM-dd');
};

const sanitizeFileSegment = value =>
  String(value || 'venue')
    .trim()
    .replace(/[^\w-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase() || 'venue';

export const buildBuzzReportCsv = ({ venue, buzz }) => {
  const summary = buzz?.summary || {};
  const score = buzz?.buzz_score ?? summary.b ?? venue?.buzz_score ?? '';
  const avg28d =
    buzz?.buzz_score_avg_28d ??
    summary.bavg_28d ??
    venue?.buzz_score_avg_28d ??
    '';
  const history = buzz?.history || [];
  const mentions = buzz?.mentions || [];
  const rows = [
    csvRow(['Venue', venue?.name || '']),
    csvRow(['Address', venue?.address || '']),
    csvRow(['Buzz score', score]),
    csvRow(['28-day average', avg28d]),
    csvRow(['Reviews score', summary.b_reviews ?? '']),
    csvRow(['Media score', summary.b_media ?? '']),
    csvRow(['Busyness score', summary.b_footfall ?? '']),
    '',
    csvRow(['History']),
    csvRow(['Date', 'Buzz score', 'Reviews', 'Media', 'Busyness']),
    ...history.map(point =>
      csvRow([
        formatHistoryDate(point.scored_at),
        point.b ?? '',
        point.b_reviews ?? '',
        point.b_media ?? '',
        point.b_footfall ?? '',
      ])
    ),
    '',
    csvRow(['Mentions']),
    csvRow(['Source', 'Title', 'Date', 'Domain', 'Link']),
    ...mentions.map(mention =>
      csvRow([
        mention.source || 'google',
        mention.title || '',
        formatMentionDate(mention),
        mentionHost(mention.domain, mention.link) || '',
        mention.link || '',
      ])
    ),
  ];

  return rows.join('\n');
};

export const downloadBuzzReport = ({ venue, buzz }) => {
  if (!venue) return;

  const fileName = `buzz-report-${sanitizeFileSegment(venue.name)}-${format(
    new Date(),
    'dd-MM-yyyy'
  )}.csv`;
  downloadCsvFile(fileName, buildBuzzReportCsv({ venue, buzz }));
};
